import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

const UserCrewRow = ({ user }) => {
  return (
    <TableRow className="custom-row">
      <TableCell>{user.id}</TableCell>
      <TableCell>{user.fullname}</TableCell>
      <TableCell>{user.email}</TableCell>
      <TableCell>{user.country}</TableCell>
    </TableRow>
  );
};

export default UserCrewRow;
